<template>
  <div class="venue-map">
    <gmap-map
      :center="venue.location"
      :zoom="17"
      mapTypeControl="false"
      :style="mapstyle"
      :options="options"
    >
      <gmap-marker
        :position="venue.location"
        :clickable="true"
        :draggable="true"
        :icon="'/img/icons/icon-pin.svg'"
        @click="center = venue.location"
      ></gmap-marker>
    </gmap-map>
    <div class="map-legend">
      <h3 v-if="!size || size != 'small'">{{ venue.name }}</h3>
      <h4 v-if="size && size == 'small'">{{ venue.name }}</h4>
      <p>{{ venue.fullAddress }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: {
        disableDefaultUI: true, // Removes all default UI elements
        draggable: false, // Disables panning
        scrollwheel: false, // Disables zooming with mousewheel
        zoomControl: false, // Hides zoom controls
        gestureHandling: "none", // Disables all touch gestures
        keyboardShortcuts: false, // Disables keyboard controls
        clickableIcons: false, // Makes POI icons non-clickable
        fullscreenControl: false, // Hides fullscreen control
        mapTypeControl: false, // Hides map type control
        streetViewControl: false,
        styles: [
          {
            elementType: "geometry",
            stylers: [{ color: "#f5f5f5" }] // Light gray base
          },
          {
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }] // Hide all icons
          },
          {
            elementType: "labels.text.fill",
            stylers: [{ color: "#616161" }] // Dark gray text
          },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#f5f5f5" }] // Light gray text outline
          },
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [{ color: "#e0e0e0" }] // Light gray borders
          },
          {
            featureType: "poi",
            stylers: [{ visibility: "off" }] // Hide all points of interest
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#ffffff" }] // White roads
          },
          {
            featureType: "road",
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }] // Hide road icons
          },
          {
            featureType: "transit",
            stylers: [{ visibility: "off" }] // Hide transit
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#e0e0e0" }] // Light gray water
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }] // Medium gray water text
          }
        ]
      }
    };
  },
  props: {
    venue: Object,
    size: String
  },
  computed: {
    mapstyle: function() {
      if (this.size && this.size == "small")
        return "width: 100%; height: 100px";
      else return "width: 100%; height: 250px";
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/variables.scss";
.venue-map {
  border-radius: 6px;
  background-color: #f2f2f2;
}
.map-legend {
  border-radius: 3px;
  background-color: white;
  border: 3px solid #f2f2f2;
  border-top: none;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  padding: 1.5rem 2.5rem;
}
.map-legend h3 {
  font-size: 1.5rem;
}
.map-legend p {
  font-size: 16px;
  margin-bottom: 0px;
}
.vue-map-container .vue-map {
  border-radius: 6px;
}
</style>
